import { ChangeDetectionStrategy, Component, input } from '@angular/core';


@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'soft-lstfix-fieldok-list-view',
    imports: [],
    templateUrl: './list-view.component.html',
    styleUrl: './list-view.component.css'
})
export class LstfixListViewComponent {

  readonly item = input<Record<string, unknown>>()
}
